import React from 'react';
import StyledStagePaginationButton from '../../styles/StyledStagePaginationButton';

export type StagePaginationProps = {
  stageCount: number;
  stage: number;
  maxStage: number;
  setStage: React.Dispatch<React.SetStateAction<number>>;
  setPageType?: React.Dispatch<React.SetStateAction<string>>;
};

const StagePagination = ({ stageCount, stage, maxStage, setStage, setPageType }: StagePaginationProps) => {
  const stageButtons = [];
  for (let i = 1; i <= stageCount; i++) {
    stageButtons.push(
      <StyledStagePaginationButton
        key={i}
        className={`${stage === i ? 'active' : ''} ${i > maxStage ? 'disabled' : ''}`}
        onClick={() => {
          if (i <= maxStage) {
            setStage(i);
            setPageType('order');
          }
        }}
      >
        {i}
      </StyledStagePaginationButton>,
    );
  }
  return (
    <div className='order-stage-pagination'>
      <p>Этапи замовлення:</p>
      {stageButtons}
    </div>);
};

export default StagePagination;